var datePickerDivID = "datepicker";
var iFrameDivID = "datepickeriframe";
let dayArrayShort = [];
// var dayArrayMed = new Array('Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat');
// var dayArrayLong = new Array('Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday');
// var monthArrayShort = new Array('Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec');
let monthArrayMed = [];
// var monthArrayLong = new Array('January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December');
var defaultDateSeparator = "-";        // common values would be "/" or "."
var defaultDateFormat = "ymd"    // valid values are "mdy", "dmy", and "ymd"
var dateSeparator = defaultDateSeparator;
var dateFormat = defaultDateFormat;
var oldDate;

function translate_datepicker() {
    document.querySelectorAll('.date_row .text').forEach((input) => {
        const hiddenField = document.getElementById(input.id + '_sql');
        const currentDate = hiddenField.value;
        const formattedDateClient = formatDate(currentDate)[0];
        const formattedDateServer = input.value;

        if (formattedDateClient !== formattedDateServer) {
            input.dataset.oldValue = input.value;
            input.value = formattedDateClient;
        }
    });
}

function zPad(num, minlength){
	num = (((num - 0) || 0) + '').split('');
	while(num.length < minlength)
		num.unshift('0');
	return num.join('');
}
// This function makes the datepicker go away when you click off of it.
function datepicker_watcher(e){
	if($('datepicker') && (e.element().up('#datepicker')===undefined) && !e.element().onclick){
		if('dtOnUpdate' in window) dtOnUpdate(e);
		if (typeof(datePickerClosed) == "function"){
			if(targetDateField) datePickerClosed(targetDateField);
		}
		if(d = $('datepicker')){
			if(d.up('#MB_content')){
				var boxSize = check_datepicker_type(true);
				Modalbox.resizeToContent(boxSize);
			}
			d.up().remove();
		}
		Event.stopObserving(document,'click',datepicker_watcher);
	}
}
function time_changed(e, field) {
	e.element().up('#datepicker').addClassName('time_changed');
	updateDateField(field, getDateString(oldDate), true, true);
	targetDateField = document.getElementsByName (field)[0];
}
function displayDatePicker(dateFieldName, displayBelowThisObject, has_time, dtFormat, dtSep){
    dayArrayShort = [
        get_language_translation('LANG_DAYS_SUNDAY_SHORT'),
        get_language_translation('LANG_DAYS_MONDAY_SHORT'),
        get_language_translation('LANG_DAYS_TUESDAY_SHORT'),
        get_language_translation('LANG_DAYS_WEDNESDAY_SHORT'),
        get_language_translation('LANG_DAYS_THURSDAY_SHORT'),
        get_language_translation('LANG_DAYS_FRIDAY_SHORT'),
        get_language_translation('LANG_DAYS_SATURDAY_SHORT')
    ];
    monthArrayMed = [
        get_language_translation('LANG_MONTHS_JANUARY_SHORT'),
        get_language_translation('LANG_MONTHS_FEBRUARY_SHORT'),
        get_language_translation('LANG_MONTHS_MARCH_SHORT'),
        get_language_translation('LANG_MONTHS_APRIL_SHORT'),
        get_language_translation('LANG_MONTHS_MAY_SHORT'),
        get_language_translation('LANG_MONTHS_JUNE_SHORT'),
        get_language_translation('LANG_MONTHS_JULY_SHORT'),
        get_language_translation('LANG_MONTHS_AUGUST_SHORT'),
        get_language_translation('LANG_MONTHS_SEPTEMBER_SHORT'),
        get_language_translation('LANG_MONTHS_OCTOBER_SHORT'),
        get_language_translation('LANG_MONTHS_NOVEMBER_SHORT'),
        get_language_translation('LANG_MONTHS_DECEMBER_SHORT')
    ];
  has_time = has_time || false;
  var targetDateField = document.getElementsByName (dateFieldName)[0];
  if (!$(displayBelowThisObject))
	displayBelowThisObject = targetDateField;
  if (dtSep)
	dateSeparator = dtSep;
  else
	dateSeparator = defaultDateSeparator;
  if (dtFormat)
	dateFormat = dtFormat;
  else
	dateFormat = defaultDateFormat;
  var x = displayBelowThisObject.offsetLeft;
  if(x>500) x=x/20;
  drawDatePicker(displayBelowThisObject, x, has_time);
  datepicker_watcher.ready = false;
}
function drawDatePicker(targetDateField, x, has_time){
  if($('datepicker')){
  	$('datepicker').up().remove();
	Event.stopObserving(document,'click',datepicker_watcher);
  }
  var dt = getFieldDate(targetDateField.value );
    if (!(dt instanceof Date) || isNaN(dt)) { // dates cannot be parsed when language is spanish so we use the normal date format.
        if ($(targetDateField.id + '_sql')) {
            dt = getFieldDate($(targetDateField.id + '_sql').value);
        }
    }
  if (!document.getElementById(datePickerDivID)) {
	Event.observe(document,'click', datepicker_watcher);
	var newNode = document.createElement("div");
	newNode.setAttribute("id", datePickerDivID);
	newNode.setAttribute("class", "dpDiv");
	newNode.setAttribute("style", "visibility: hidden;");
	newNode = new Element('div',{'id':datePickerDivID+'_outer'}).update(newNode);
	targetDateField.up('div,p').appendChild(newNode);
  }
  var pickerDiv = document.getElementById(datePickerDivID);
  pickerDiv.style.position = "absolute";
  pickerDiv.style.left = x + "px";
  pickerDiv.style.visibility = (pickerDiv.style.visibility == "visible" ? "hidden" : "visible");
  pickerDiv.style.display = (pickerDiv.style.display == "block" ? "none" : "block");
  pickerDiv.style.zIndex = 10000;
  return refreshDatePicker(targetDateField.name || targetDateField.id, has_time, dt.getFullYear(), dt.getMonth(), dt.getDate());
}
function refreshDatePicker(dateFieldName, has_time, year, month, day){
  var thisDay = new Date();
  if ((month >= 0) && (year > 0)) {
	thisDay = new Date(year, month, 1);
  } else {
	day = thisDay.getDate();
	thisDay.setDate(1);
  }
  var crlf = "\r\n";
  var TABLE = "<table>" + crlf;
  var xTABLE = "</table>" + crlf;
  var TR = "<tr>";
  var TR_title = "<tr class='title'>";
  var TR_days = "<tr>";
  var TR_todaybutton = "<tr>";
  var xTR = "</tr>" + crlf;
  var TD = "<td ";    // leave this tag open, because we'll be adding an onclick event
  var TD_title = "<td colspan=3 class='title'>";
  var TD_buttons = "<td>";
  var TD_wide_buttons = "<td class='dpWideButton'>";
  var TD_todaybutton = "<td colspan=7 class='base'>";
  var TD_days = "<th>";
  var TD_selected = "<td class='highlight' ";    // leave this tag open, because we'll be adding an onclick event
  var xTD = "</td>" + crlf;
  var DIV_title = "<div>";
  var DIV_selected = "<div>";
  var xDIV = "</div>";
  var html = TABLE;
  html += TR_title;
  html += TD_wide_buttons + getButtonCode(dateFieldName, thisDay, -12, "&#171;",has_time) + xTD;
  html += TD_buttons + getButtonCode(dateFieldName, thisDay, -1, "&#8249;",has_time) + xTD;
  html += TD_title + DIV_title + monthArrayMed[ thisDay.getMonth()] + " " + thisDay.getFullYear() + xDIV + xTD;
  html += TD_buttons + getButtonCode(dateFieldName, thisDay, 1, "&#8250;",has_time) + xTD;
  html += TD_wide_buttons + getButtonCode(dateFieldName, thisDay, 12, "&#187;",has_time) + xTD;
  html += xTR;
  var today = new Date();
  html += TR_todaybutton + TD_todaybutton;
  html += "<input type='button' onclick='return updateDateField(\"" + dateFieldName + "\",\"" + getDateString(today) + "\",false);' value='" + get_language_translation('LANG_TODAY') + "' /><br />";
  html += xTD + xTR;
  html += TR_days;
  for(var i = 0; i < dayArrayShort.length; i++)
	html += TD_days + dayArrayShort[i] + xTD;
  html += xTR;
  html += TR;
  for (var i = 0; i < thisDay.getDay(); i++)
	html += TD + "&nbsp;" + xTD;
  do {
	var dayNum = thisDay.getDate();
	var TD_onclick = " onclick=\"return updateDateField('" + dateFieldName + "', '" + getDateString(thisDay) + "',"+(has_time?'true':'false')+");\">";
	if (dayNum == day)
	  html += TD_selected + TD_onclick + DIV_selected + dayNum + xDIV + xTD;
	else
	  html += TD + TD_onclick + dayNum + xTD;
	if (thisDay.getDay() == 6)
	  html += xTR + TR;
	thisDay.setDate(thisDay.getDate() + 1);
  } while (thisDay.getDate() > 1)
  if (thisDay.getDay() > 0) {
	for (i = 6; i > thisDay.getDay(); i--)
	  html += TD + "&nbsp;" + xTD;
  }
  html += xTR;
  var targetField = document.getElementsByName(dateFieldName).item(0);
  targetField.arr = $(targetField.id+'_sql').value.split(/[ :\-]+/);
  if (targetField.arr[0])
	  oldDate = new Date(targetField.arr[0],targetField.arr[1]-1,targetField.arr[2]);
  else
	  oldDate = new Date();
  // var todayString = "Today is " + dayArrayMed[today.getDay()] + ", " + monthArrayMed[ today.getMonth()] + " " + today.getDate();
  html += TR_todaybutton + TD_todaybutton;
  html += "<input type='button' onclick='return refreshDatePicker(\"" + dateFieldName + "\","+(has_time?'true':'false')+");' value='" + get_language_translation('LANG_THIS_MONTH') + "'/> ";
  html += "<input type='button' onclick='return updateDateField(\"" + dateFieldName + "\",\"" + getDateString(oldDate) + "\","+(has_time?'true':'false')+");' value='" + get_language_translation('LANG_BTN_SUBMIT') + "'/>";
  html += xTD + xTR;
  if(has_time){
	  if (targetField.arr[4])
		  targetField.min = targetField.arr[4];
	  else
		  targetField.min = 0;
	  if(targetField.arr[3] > 12){
		  targetField.hr = targetField.arr[3]-12;
		  targetField.ap = 'PM';
	  } else if(targetField.arr[3] == 12) {
		  targetField.hr = 12;
		  targetField.ap = 'PM';
	  } else if(targetField.arr[3] == 0) {
		  targetField.hr = 12;
		  targetField.ap = 'AM';
	  } else if(targetField.arr[3]){
		  targetField.hr = targetField.arr[3];
		  targetField.ap = 'AM';
	  }
	  else {
		  targetField.hr = 12;
		  targetField.ap = 'PM';
	  }
	  html += TR + TD + ' colspan="7"><b><select id="dp_hrs" class="timeField">';
	  for (i = 1; i < 13; i++) {
		  html += '<option value="'+(i < 10 ? '0' : '') + i + '"'+(targetField.hr == i ? ' selected' : '')+'>'+(i < 10 ? '0' : '') + i + '</option>';
	  }
	  html += '</select>:<select id="dp_min" class="timeField">';
	  for (i = 0; i < 60; i++) {
		  html += '<option value="'+(i < 10 ? '0' : '') + i + '"'+(targetField.min == i ? ' selected' : '')+'>'+(i < 10 ? '0' : '') + i + '</option>';
	  }
	  html += '</select> <select id="dp_ap" class="timeField"><option value="AM"'+(targetField.ap.toLowerCase()=='am'?' selected':'')+'>AM</option><option value="PM"'+(targetField.ap.toLowerCase()=='pm'?' selected':'')+'>PM</option></select></b>' + xTD + xTR;
  }
  html += xTABLE;
  document.getElementById(datePickerDivID).innerHTML = html;
  $(datePickerDivID).select('.timeField').invoke('observe','change',function(ev) {time_changed(ev, dateFieldName);});
  if($(datePickerDivID).up('#MB_content')){
	var boxSize = check_datepicker_type();
  	Modalbox.resizeToContent(boxSize);
  }
  return false;
}
function getButtonCode(dateFieldName, dateVal, adjust, label,has_time){
  var newMonth = (dateVal.getMonth () + adjust) % 12;
  var newYear = dateVal.getFullYear() + parseInt((dateVal.getMonth() + adjust) / 12);
  if (newMonth < 0) {
	newMonth += 12;
	newYear += -1;
  }
  return "<input type='button' class='dpButton' onclick='return refreshDatePicker(\"" + dateFieldName + "\", "+(has_time?'true':'false')+", " + newYear + ", " + newMonth + ");' value='" + label + "'/>";
}
function getDateString(dateVal){
  var dayString = "00" + dateVal.getDate();
  var monthString = "00" + (dateVal.getMonth()+1);
  dayString = dayString.substring(dayString.length - 2);
  monthString = monthString.substring(monthString.length - 2);
  var ret = '';
  switch (dateFormat) {
	case "dmy" :
	  return dayString + dateSeparator + monthString + dateSeparator + dateVal.getFullYear();
	case "ymd" :
	  return dateVal.getFullYear() + dateSeparator + monthString + dateSeparator + dayString;
	case "mdy" :
	default :
	  return monthString + dateSeparator + dayString + dateSeparator + dateVal.getFullYear();
  }
}
function getFieldDate(dateString){
  var dateVal;
  var dArray;
  var d, m, y;
  try {
	dArray = splitDateString(dateString);
	if (dArray) {
	  switch (dateFormat) {
		case "dmy" :
		  d = parseInt(dArray[0], 10);
		  m = parseInt(dArray[1], 10) - 1;
		  y = parseInt(dArray[2], 10);
		  break;
		case "ymd" :
		  d = parseInt(dArray[2], 10);
		  m = parseInt(dArray[1], 10) - 1;
		  y = parseInt(dArray[0], 10);
		  break;
		case "mdy" :
		default :
		  d = parseInt(dArray[1], 10);
		  m = parseInt(dArray[0], 10) - 1;
		  y = parseInt(dArray[2], 10);
		  break;
	  }
	  dateVal = new Date(y, m, d);
	} else if (dateString) {
	  dateVal = new Date(dateString);
	} else {
	  dateVal = new Date();
	}
  } catch(e) {
	dateVal = new Date();
  }
  return dateVal;
}
function splitDateString(dateString){
  var dArray;
  if (dateString.indexOf("/") >= 0)
	dArray = dateString.split("/");
  else if (dateString.indexOf(".") >= 0)
	dArray = dateString.split(".");
  else if (dateString.indexOf("-") >= 0)
	dArray = dateString.split("-");
  else if (dateString.indexOf("\\") >= 0)
	dArray = dateString.split("\\");
  else
	dArray = false;
  return dArray;
}
function datePickerClosed(dateField, stay_open){
	var dates = formatDate($F(dateField));
	var id = dateField.id.replace('_sql','');
	if($(id+'_sql')) $(id+'_sql').value = dates[1];
	if($(id+'_parsed')) $(id+'_parsed').innerHTML = dates[0];
	if($(id)){
		$(id).value = dates[0];
		$(id).fire('pseudo:click');

		if(['rep_start_date', 'rep_end_date'].includes(id)){ // force the datepicker to make livetable request
			var filter_div = $(id).up('.filter');
			var table_id = filter_div.id.replace('-filter', '');
			
			// Check if table with the ID exists and has livetable class to protect non livetable date_picker processes 
			var table = $(table_id);
			if(table && table.hasClassName('livetable')){
				ltDelayedRequest(table_id);
			}
		}
	}
	if(d = $('datepicker')){
		if(d.up('#MB_content')){
			var boxSize = check_datepicker_type(stay_open == undefined ? true : false);
			Modalbox.resizeToContent(boxSize);
		}
		if (!stay_open)
			d.up().remove();
	}
	if (!stay_open)	Event.stopObserving(document,'click',datepicker_watcher);
}
var targetDateField;
function updateDateField(dateFieldName, dateString, has_time, stay_open){
  targetDateField = document.getElementsByName (dateFieldName)[0];
  if(!targetDateField){
  	$('datepicker').up().remove();
	Event.stopObserving(document,'click',datepicker_watcher);
  	return;
  } else {
	  const dirtyFlagElement = document.getElementById(targetDateField.id + '_dirty');
	  if (dirtyFlagElement) {
		  dirtyFlagElement.value = true;
	  }
  }
  if(has_time){
	  targetDateField.ap = $F('dp_ap');
	  targetDateField.hr = $F('dp_hrs');
	  targetDateField.min = $F('dp_min');
	  targetDateField.time = ' ';
	  if(Number(targetDateField.hr)){
	  	if(targetDateField.ap.blank()){
	  		targetDateField.hr = targetDateField.hr % 24;
	  		targetDateField.hr = targetDateField.hr.length==1?'0'+targetDateField.hr:targetDateField.hr;
	  	} else if(targetDateField.ap == 'AM'){
	  		targetDateField.hr = ((Number(targetDateField.hr)) % 12);
	  		targetDateField.hr = targetDateField.hr.length==1?'0'+targetDateField.hr:targetDateField.hr;
	  	} else if(targetDateField.ap == 'PM'){
	  		targetDateField.hr = (targetDateField.hr<12&&targetDateField.hr>0)?Number(targetDateField.hr)+12:12;
	  	}
		targetDateField.hr = targetDateField.min.length==1?'0'+targetDateField.hr:targetDateField.hr;
	  	if(targetDateField.min.blank())
	  		targetDateField.min = '00';
	  	else
			targetDateField.min = targetDateField.min.length==1?'0'+targetDateField.min:targetDateField.min;
		targetDateField.time += targetDateField.hr+':'+targetDateField.min;
	  }
  } else targetDateField.time = '';
  if (dateString){
	targetDateField.value = dateString + (targetDateField.time.blank()?'':targetDateField.time);
  }
  var pickerDiv = document.getElementById(datePickerDivID);
  if (!stay_open) {
	  pickerDiv.style.visibility = "hidden";
	  pickerDiv.style.display = "none";
	  //adjustiFrame();
	  if(targetDateField){
	  	if(targetDateField.visible() && targetDateField.type!='hidden')
		  	targetDateField.focus();
	  }
  }
  if ((dateString) && (typeof(datePickerClosed) == "function") )
	datePickerClosed(targetDateField, stay_open);
	if(pickerDiv.up('#MB_content')){
		var boxSize = check_datepicker_type();
		Modalbox.resizeToContent(boxSize);
	}
  if(dateString){
	  if(targetDateField.onchange)
			  targetDateField.onchange();
  }

  return false;
}
function adjustiFrame(pickerDiv, iFrameDiv){
  var is_opera = (navigator.userAgent.toLowerCase().indexOf("opera") != -1);
  if (is_opera)
	return;
  try {
	if (!document.getElementById(iFrameDivID)) {
	  var newNode = document.createElement("iFrame");
	  newNode.setAttribute("id", iFrameDivID);
	  newNode.setAttribute("src", "javascript:false;");
	  newNode.setAttribute("scrolling", "no");
	  newNode.setAttribute ("frameborder", "0");
	  document.body.appendChild(newNode);
	}
	if (!pickerDiv)
	  pickerDiv = document.getElementById(datePickerDivID);
	if (!iFrameDiv)
	  iFrameDiv = document.getElementById(iFrameDivID);
	try {
	  iFrameDiv.style.position = "absolute";
	  iFrameDiv.style.width = pickerDiv.offsetWidth;
	  iFrameDiv.style.height = pickerDiv.offsetHeight ;
	  iFrameDiv.style.top = pickerDiv.style.top;
	  iFrameDiv.style.left = pickerDiv.style.left;
	  iFrameDiv.style.zIndex = pickerDiv.style.zIndex - 1;
	  iFrameDiv.style.visibility = pickerDiv.style.visibility ;
	  iFrameDiv.style.display = pickerDiv.style.display;
	} catch(e) {
	}
  } catch (ee) {
  }
}
function check_datepicker_type(close = false){
	if(am.$('#MB_content').find('.notes_form div.occurance_date').length > 0)
		var boxSize = { custom_resize_height: close ? 240 : 340 }

	return boxSize;
}